import {WhiteList} from '@hconnect/common/hproduce'
import {AxiosError} from 'axios'
import React, {ErrorInfo} from 'react'

import {HLog} from '../../common/utils/logging'
import {ErrorPage} from '../../pages/ErrorPage'

type ErrorTypes = AxiosError | Error

export type HttpErrorHandler = (err: ErrorTypes) => void

export const HttpErrorHandlerContext = React.createContext<HttpErrorHandler | undefined>(undefined)

export class GlobalErrorBoundary extends React.Component<
  {whiteList: WhiteList; children?: React.ReactNode},
  {error: ErrorTypes | undefined}
> {
  /**
   * This is the default HttpErrorHandler, i.e. whenever an HTTP error occurs and is not handled
   * by the calling component, we handle it globally and show the HTTP error details on the
   * global error page
   */
  private readonly errorHandler: HttpErrorHandler

  constructor(props: {whiteList: WhiteList}) {
    super(props)
    this.state = {error: undefined}

    this.errorHandler = (err: ErrorTypes) => {
      this.setState({error: err})
      HLog('cockpit').error(err)
    }
  }

  static getDerivedStateFromError(error) {
    return {hasError: true, error}
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    HLog('cockpit').extras({info}).error(error)
  }

  render() {
    if (this.state.error !== undefined) {
      return (
        <div onClick={() => this.setState({error: undefined})}>
          <ErrorPage error={this.state.error} whiteList={this.props.whiteList} />
        </div>
      )
    } else {
      return (
        <HttpErrorHandlerContext.Provider value={this.errorHandler}>
          {this.props.children as React.ReactNode}
        </HttpErrorHandlerContext.Provider>
      )
    }
  }
}
